module.exports = __webpack_public_path__ + "static/assets/d5be660776661c9358c0bd5a2d7d629f.svg";